import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ScatterChart, XAxis, YAxis, Scatter, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { EVENT_COLORS, CustomLegend, legendEventColors} from "./utils/ChartUtils";
import { isAppleWebKit, sampleData } from './utils/safariUtils'

const isSafari = isAppleWebKit();

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


export default function SprayChart(props: any) {
  const [sprayData, setSprayData] = useState<any[]>([]);
  useEffect(() => {
    fetch(props.prod ? "https://oriolebird.pythonanywhere.com/hitter-spray/" + props.id + '/' + props.season + '/f' : "/hitter-spray/" + props.id + '/' + props.season + '/f')
      .then((res) => res.json())
      .then((pData) => {
        //console.log("Spray Data for ", props.season, pData);
        setSprayData(pData)
      });
  }, [props.id, props.prod, props.season]);

  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }

  const renderTooltip = (props: any) => {
    const { active, payload } = props;

    if (active && payload && payload.length) {
      const data = payload[0] && payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: '#fff',
            border: '1px solid #999',
            margin: 0,
            padding: 10,
          }}
        >
          <p>
            {data.des}
          </p>
          <p>Pitch: {data.release_speed} mph {data.pitch_name}</p>
          <p>Distance: {data.hit_distance_sc} ft</p>
        </div>
      );
    }

    return null;
  };

  const w = 350

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "570px" : " 100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor:
                  props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                    ? teamColors[props.playerInfoProp.common.teamInfo.MLB_AbbName][0]
                    : teamColors["FA"][0],
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color:
                        props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                          ? teamColors[
                          props.playerInfoProp.common.teamInfo.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    Spray Chart
                  </span>
                </Typography>
              </Grid>
            </div>
            <ResponsiveContainer width={w} height={w * .9} style={{marginTop: 30}}>
              <ScatterChart margin={{ top: w * .02, right: w * .04, bottom: 0, left: -w * .1 }}>
                <XAxis type="number" dataKey="hc_x" name="x" unit="ft" domain={[-275, 275]} tick={false} axisLine={false} label={""} tickCount={11} interval={0} />
                <YAxis type="number" dataKey="hc_y" name="y" unit="ft" domain={[-10, 450]} tick={false} axisLine={false} label={""} tickCount={11} interval={0} />
                <svg>
                  <path
                    d={`M ${w * .34} ${w * .68} Q ${w * .5} ${w * .41} ${w * .66} ${w * .68}`}
                    stroke="black"
                    strokeWidth={w * .004}
                    fill="none"
                  />

                  {/* Bases */}
                  <rect x={w * .93} y={w * .05} width={w * .02} height={w * .02} fill="white" stroke="black" strokeWidth={w * .002} transform="rotate(45)" />
                  <rect x={w * .76} y={w * .05} width={w * .02} height={w * .02} fill="white" stroke="black" strokeWidth={w * .002} transform="rotate(45)" />
                  <rect x={w * .76} y={w * .22} width={w * .02} height={w * .02} fill="white" stroke="black" strokeWidth={w * .002} transform="rotate(45)" />

                  {/* Pitcher's mound */}
                  <circle cx={w * .5} cy={w * .704} r={w * .03} fill="#8B4513" stroke="white" strokeWidth={w * .004} />
                  <circle cx={w * .5} cy={w * .704} r={w * .006} fill="white" />

                  {/* Foul line at +45 degrees */}
                  <line
                    x1={w * .5}
                    y1={w * .85}
                    x2={w * .07}
                    y2={w * .396}
                    stroke="black"
                    strokeWidth={w * .004}
                  />

                  {/* Right foul line (from home plate to right field wall) */}
                  <line
                    x1={w * .5}
                    y1={w * .85}
                    x2={w * .93}
                    y2={w * .396}
                    stroke="black"
                    strokeWidth={w * .004}
                  />

                  {/* Outfield wall arc - simplified as circular arc */}
                  <path
                    d={`M ${w * .07} ${w * .396} Q ${w * .5} ${w * -.22} ${w * .93} ${w * .396}`}
                    stroke="black"
                    strokeWidth={w * .004}
                    fill="none"
                  />
                </svg>

                <Tooltip cursor={{ strokeDasharray: '3 3' }} wrapperStyle={{ zIndex: 100 }} content={renderTooltip} />
                <Scatter name="Spray Chart" data={isSafari ? sampleData(sprayData, 500, 'events') : sprayData} fill="#8884d8" isAnimationActive={!isSafari}>
                  {(isSafari ? sampleData(sprayData, 500, 'events') : sprayData).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={EVENT_COLORS[entry.events]} />
                  ))}
                </Scatter>
              </ScatterChart>
            </ResponsiveContainer>
            <CustomLegend colors={legendEventColors} />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}